export default __webpack_public_path__ + "static/media/fusion-012.9a838dc9.svg";